module.exports = __webpack_public_path__ + "img/big_1_61.22a940fa.png";